import { Button, LinkButton, ModalCloseButton, ModalContent, ModalRoot, UIHeading2 } from '@cian/ui-kit';
import { IconActionClose12 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import errorImage from './assets/image.png';

import styles from './ChatsLinkErrorModal.css';
import { EChatsLinkErrorType, TAlertChatsLinkError } from '../../types/alert';
import { useApplicationContext } from '../../utils/applicationContext';

type TChatsLinkErrorModalProps = TAlertChatsLinkError & {
  text: string;
  onClose: VoidFunction;
  onShow: VoidFunction;
};

export const ChatsLinkErrorModal: React.FC<TChatsLinkErrorModalProps> = ({ type, retryUrl, text, onClose, onShow }) => {
  const {
    custom: { realDevice },
  } = useApplicationContext();
  const isMobileView = realDevice === 'phone';

  React.useEffect(onShow, [onShow]);

  return (
    <ModalRoot open onOpenChange={onClose}>
      <ModalContent size="S" data-testid="ChatsLinkErrorModal">
        <ModalCloseButton
          size="XS"
          title="Закрыть"
          theme="fill_light"
          icon={<IconActionClose12 color="current_color" />}
          data-testid="ChatsLinkErrorModalCloseIcon"
        />

        <div className={styles['inner']}>
          <div className={styles['content']}>
            <img src={errorImage} alt="Иконка ошибки" width={72} height={72} />

            <UIHeading2 textAlign="center" as="div" whiteSpace="pre-line">
              {text}
            </UIHeading2>
          </div>

          {type === EChatsLinkErrorType.UnknownError && (
            <div className={styles['footer']}>
              <LinkButton
                href={retryUrl}
                theme="fill_secondary"
                size={isMobileView ? 'L' : 'M'}
                fullWidth={isMobileView}
                data-testid="ChatsLinkErrorModalLinkButton"
              >
                Обновить
              </LinkButton>
            </div>
          )}

          {type === EChatsLinkErrorType.ResolveError && isMobileView && (
            <div className={styles['footer']}>
              <Button
                onClick={onClose}
                size="L"
                theme="fill_secondary"
                fullWidth
                data-testid="ChatsLinkErrorModalCloseButton"
              >
                Закрыть
              </Button>
            </div>
          )}
        </div>
      </ModalContent>
    </ModalRoot>
  );
};
